import React, { useEffect, useState } from 'react';

import SimpleAggregation from 'components/AggregationCards/SimpleAggregation';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import Section from 'components/Section';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GroupedListModel } from 'models/groupedList';
import RuleSelection from 'screens/containers/RuleSelection';
import { htmlT } from 'utils/generic';

import { Scaffold } from '../../styles';

interface Props {
  onConfirmSelection: (rule: GroupedListModel) => void;
  onCloseModal: () => void;
  onAdd: () => void;
  showRulesSelection: boolean;
  rule: GroupedListModel;
  groupTarget: string;
  ruleSelected: any;
  isFromSelection?: boolean;
  originRule?: string;
  errors: any;
}

const GroupPolicies = ({
  rule,
  ruleSelected,
  groupTarget,
  showRulesSelection,
  isFromSelection,
  originRule,
  errors,
  onCloseModal,
  onAdd,
  onConfirmSelection,
}: Props) => {
  const { t } = useStoreTranslation();
  const [ruleName, setRuleName] = useState<string | undefined>('');
  const [simpleAggIsActive, setSimpleAggIsActive] = useState(false);

  useEffect(() => {
    console.log(errors, rule)
    if (isFromSelection) {
      setRuleName(originRule || t('group.politics.ruleDefaultValue'));
    } else {
      setRuleName(rule?.name || undefined);
    }

    setSimpleAggIsActive(isFromSelection || rule.id !== '');
  }, [rule, originRule, isFromSelection]); // eslint-disable-line react-hooks/exhaustive-deps
  // TODO: check dependencies or refactor

  const handleClickSimpleAggregation = () => {
    if (!isFromSelection) onAdd();
  };

  const policySelected = {
    value: rule.id,
    error: errors?.rule?.name,
  };

  return (
    <Section
      title={t('group.politics.title')}
      details={htmlT(t, 'group.politics.details')}
      detailsOptional={t('group.politics.detailsOptional')}
    >
      <ApplicationOverlayContent sidebar show={showRulesSelection} onClose={onCloseModal}>
        <Scaffold title={t('group.politics.title')}>
          <RuleSelection
            showRulesSelection={showRulesSelection}
            groupTarget={groupTarget}
            ruleSelected={ruleSelected}
            onConfirmSelection={onConfirmSelection}
            onCloseSelectionScreen={onCloseModal}
          />
        </Scaffold>
      </ApplicationOverlayContent>
      <SimpleAggregation
        placeholder={t('group.politics.addPolicy')}
        icon="policy"
        title={ruleName}
        active={simpleAggIsActive}
        onAdd={handleClickSimpleAggregation}
        onClick={handleClickSimpleAggregation}
        errorMessage={policySelected.error}
      />
    </Section>
  );
};

export default GroupPolicies;
